import React, { useEffect, useState } from 'react';
import { Box, Card, Grid, Pagination } from '@mui/material';
import { getAllBox, getFilteredNewsData, getFilterMatrimonyNewsData } from '../../../Services/UserServices';
import styled from '@emotion/styled';
import LatestSession from '../../Components/NewsSessionComponents/LatestSession';
import { saveToLocalStorage, scrollToLastVisitedItem, } from '../../../Helper/helper';
import '../../../Styles/UserMatrimony.css'
import Loader from '../../../Components/Loader/Loader';
import { useLocation, useNavigate } from 'react-router-dom';
import parse from 'html-react-parser';

const Item = styled(Card)(({ theme }) => ({
  height: '100%',
  width: '100%',
  boxShadow: 'none',
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
  bgcolor: '#fff',
  '@media (max-width: 768px)': {
    borderBottom: '2px solid hsla(260,11%,85%,1)'
  },
}));

const style = {
  marginBottom: "20px"
}

function Matrimonypage() {
  const navigate = useNavigate();

  const { state } = useLocation();
  const { matrimonyType } = state || {};

  const [ads, setAds] = useState([]);
  const [filteredNews, setFilteredNews] = useState([]);
  const [latestNews, setLatestNews] = useState([]);

  // Loader
  const [loading, setLoading] = useState(false);

  // Pagination
  const itemsPerPage = 9;
  const [page, setPage] = useState(1);
  const pageCount = Math.ceil(filteredNews.length / itemsPerPage);
  const paginatedNews = filteredNews.slice((page - 1) * itemsPerPage, page * itemsPerPage);

  const getMatrimonyData = async () => {
    try {
      setLoading(true);
      await getFilterMatrimonyNewsData(matrimonyType || "all").then((res) => {
        let data = res?.data?.latestMatrimonyNews;
        setFilteredNews(data || []);
        setPage(1);
      })
    } catch (err) {
      setLoading(false);
      console.log(err)
    } finally {
      setLoading(false);
    }
  }

  const getData = async () => {
    setLoading(true);
    window.scrollTo(0, 0)
    try {
      await getAllBox().then((res) => {
        let data = res?.data?.ads;
        setAds(data);
      })

      let filterCount = {
        "categoryName": "",
        "type": "Main",
        "count": 5
      }
      await getFilteredNewsData(filterCount).then((res) => {
        let data = res?.data?.latestNews;
        setLatestNews(data);
      })
    } catch (err) {
      setLoading(false);
      console.log(err)
    } finally {
      setLoading(false);
      scrollToLastVisitedItem();
    }
  }

  useEffect(() => {
    getMatrimonyData();
  }, [matrimonyType]);

  useEffect(() => {
    getData();
  }, []);

  const AdvertiseItem = ({ item, index }) => {
    const renderFilteredContent = (htmlContent) => {
      let arr = [];
      parse(htmlContent, {
        replace: (domNode) => {
          arr.push(domNode);
          return null;
        },
      });

      const imageNode = arr.find((node) => node?.name === 'img');
      const iframeNode = arr.find((node) => node?.name === 'iframe');
      const descriptionNode = arr.filter((node) => node?.type === "text");

      // Image rendering
      const image = imageNode ? (
        <img
          alt="News"
          src={imageNode?.attribs?.src ? imageNode?.attribs?.src : item?.matrimonytype === "bride" ? '/matrimonyAvatars/male.jpeg' : '/matrimonyAvatars/female.jpeg'}
          className='matrimony-and-orbitary-image'
        />
      ) : iframeNode ? (
        // Iframe rendering
        <iframe src={iframeNode?.attribs?.src}
          className='obitary-matrimony-iframe-style'
          title="Video"
        />
      ) : (
        // Default image rendering
        <img
          alt="Default"
          src={item?.matrimonytype === "bride" ? '/matrimonyAvatars/male.jpeg' : '/matrimonyAvatars/female.jpeg'}
          className='matrimony-and-orbitary-image'
        />
      );

      const description = descriptionNode.map((node) => node?.data).join(" ").trim();

      return { image, description };
    };

    const { image, description } = renderFilteredContent(item?.content);
    return (
      <div key={index} style={{ cursor: 'pointer' }} onClick={() => { saveToLocalStorage(window.location.pathname, window.scrollY); navigate(`/user/news/details/${item?.slug}`) }}>
        <div>
          {image}
        </div>
        <div>
          <p className="matrimony-id-text">{item?.title}</p>
          <p className='matrimony-desc-text'>{description}</p>
        </div>
      </div>
    );
  }

  if (loading) {
    return <Loader />
  }

  return (
    <div>
      <div className='matrimony-btn-flex'>
        <h1>{matrimonyType === "all" || matrimonyType === "" || matrimonyType === undefined || matrimonyType === null ? "Brides & Grooms" : matrimonyType === "bride" ? "Wanted Brides" : "Wanted Grooms"}</h1>
      </div>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12} lg={9}>
          <Grid container spacing={2}>
            {filteredNews.length === 0 ? (
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <div style={{ fontSize: 20, fontWeight: 'bold', padding: 20, textAlign: 'center' }}>No Records Found...</div>
              </Grid>
            ) : (
              paginatedNews.map((item, index) => (
                <Grid item xs={12} sm={12} md={4} lg={4} key={index}>
                  <Item>
                    <AdvertiseItem item={item} index={index} />
                  </Item>
                </Grid>
              )))}
          </Grid>
          {pageCount > 1 && (
            <Box sx={{ display: 'flex', justifyContent: 'center', padding: '30px 0' }}>
              <Pagination
                count={pageCount}
                page={page}
                onChange={(event, value) => { setPage(value); window.scrollTo(0, 0); }}
                color="primary"
                shape="rounded"
              />
            </Box>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={3}>
          <LatestSession filteredNews={latestNews} />
          {ads.map((ads, index) => (
            <Box style={style} key={index}>
              <img alt="complex" src={ads?.image?.url} style={{ width: '100%', height: '100%' }} />
            </Box>
          ))}
        </Grid>
      </Grid>
    </div>


  )
}

export default Matrimonypage;